import axios from 'axios';
import Cookies from 'js-cookie';

export const requestASelfSignupLink = ({ params }) => {
  return axios({
    method: 'post',
    url: `/signup/self-invite/`,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const resendEmailOtp = ({ params }) => {
  return axios({
    method: 'post',
    url: `/signup/email-code-resend/`,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const verifySignupEmailOtp = ({ params }) => {
  return axios({
    method: 'post',
    url: '/signup/email-code-verify/',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const setSelfSignPassword = ({ params }) => {
  return axios({
    method: 'post',
    url: '/signup/self-set-password/',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const createSelfSignupAccount = ({ params }) => {
  return axios({
    method: 'post',
    url: '/signup/self-signup/',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};
